import { axiosInstance } from '@/modules/shared/lib/axios'
import { CompanyGroupDto, CreateCompanyGroupRequest } from './types'

type Props = {
  companyId: string
  payload: CreateCompanyGroupRequest
}

export function createCompanyGroup({ companyId, payload }: Props) {
  return axiosInstance.post<CompanyGroupDto>(
    `/config-api/${companyId}/configuration/admin/companies/addGroup`,
    payload
  )
}
